import { render, staticRenderFns } from "./employmentRegistration.vue?vue&type=template&id=6d2b2ba6"
import script from "./employmentRegistration.vue?vue&type=script&lang=js"
export * from "./employmentRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports